export default __webpack_public_path__ + "static/media/chatu_yapa.7d50f3d8.jpg";